import { md5 } from 'js-md5';

/**
 * Build a Gravatar avatar URL for the given email. Gravatar matches by
 * MD5 of the lowercased + trimmed email. We append `d=404` so missing
 * avatars return a 404 instead of a generic placeholder — the `AttendeeRow`
 * component's `onError` handler catches the 404 and falls back to initials.
 *
 * `s=80` requests an 80px image; the UI displays at 30px (collapsed) or
 * 40px (expanded), so 80px provides a clean 2x for retina without
 * over-fetching.
 *
 * Gravatar's avatar endpoint still supports MD5 (the profile-data API
 * has moved to SHA256, but we only use avatars here).
 */
export function gravatarUrlFor(email: string): string {
  const normalized = email.trim().toLowerCase();
  const hash = md5(normalized);
  return `https://www.gravatar.com/avatar/${hash}?d=404&s=80`;
}
